import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import './footer.css';

const LEGAL_LINKS = [
  { to: '/app/marketing-information', labelKey: 'navigator.marketing' },
  { to: '/app/privacy-policy', labelKey: 'navigator.privatePolicy' },
  { to: '/app/terms-of-use', labelKey: 'navigator.useTerm' },
] as const;

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="soundpill-site-footer">
      <div className="soundpill-site-footer__meta">
        <p className="soundpill-site-footer__line">{t('footer.companyLine')}</p>
        <p className="soundpill-site-footer__line">{t('footer.telecomReport')}</p>
        <p className="soundpill-site-footer__line">{t('footer.addressLine')}</p>
      </div>

      <ul className="soundpill-site-footer__legal">
        {LEGAL_LINKS.map(({ to, labelKey }) => (
          <li key={to}>
            <Link to={to} className="soundpill-site-footer__link">
              {t(labelKey)}
            </Link>
          </li>
        ))}
      </ul>
    </footer>
  );
}
